import { createV3Queries } from "@query/utils/createV3Queries";
import { profitAndLossApi } from "@api";

export const queriesProfitAndLoss = createV3Queries(
  "profitAndLossApi",
  profitAndLossApi
);
